export default {
    props: {
        scaleEndAngle: {
            type: Number,
            default: undefined,
            kComposite: 'scale.endAngle'
        }, 

        scaleLabelsBackground: {
            type: String,
            default: undefined,
            kComposite: 'scale.labels.background'
        }, 

        scaleLabelsBorderColor: {
            type: String,
            default: undefined,
            kComposite: 'scale.labels.border.color'
        }, 

        scaleLabelsBorderDashType: {
            type: String,
            default: undefined,
            kComposite: 'scale.labels.border.dashType'
        }, 

        scaleLabelsBorderOpacity: {
            type: Number,
            default: undefined,
            kComposite: 'scale.labels.border.opacity'
        }, 

        scaleLabelsBorderWidth: {
            type: Number,
            default: undefined,
            kComposite: 'scale.labels.border.width'
        }, 


        scaleLabelsColor: {
            type: String,
            default: undefined,
            kComposite: 'scale.labels.color'
        }, 

        scaleLabelsFont: {
            type: String,
            default: undefined,
            kComposite: 'scale.labels.font'
        }, 

        scaleLabelsFormat: {
            type: String,
            default: undefined,
            kComposite: 'scale.labels.format'
        }, 

        scaleLabelsMargin: {
            type: Number,
            default: undefined,
            kComposite: 'scale.labels.margin'
        }, 

        scaleLabelsMarginTop: {
            type: Number,
            default: undefined,
            kComposite: 'scale.labels.margin.top'
        }, 

        scaleLabelsMarginBottom: {
            type: Number,
            default: undefined,
            kComposite: 'scale.labels.margin.bottom'
        }, 

        scaleLabelsMarginLeft: {
            type: Number,
            default: undefined,
            kComposite: 'scale.labels.margin.left'
        }, 

        scaleLabelsMarginRight: {
            type: Number,
            default: undefined,
            kComposite: 'scale.labels.margin.right'
        }, 


        scaleLabelsPadding: {
            type: Number,
            default: undefined,
            kComposite: 'scale.labels.padding'
        }, 

        scaleLabelsPaddingTop: {
            type: Number,
            default: undefined,
            kComposite: 'scale.labels.padding.top'
        }, 

        scaleLabelsPaddingBottom: {
            type: Number,
            default: undefined,
            kComposite: 'scale.labels.padding.bottom'
        }, 

        scaleLabelsPaddingLeft: {
            type: Number,
            default: undefined,
            kComposite: 'scale.labels.padding.left'
        }, 

        scaleLabelsPaddingRight: {
            type: Number,
            default: undefined,
            kComposite: 'scale.labels.padding.right'
        }, 


        scaleLabelsPosition: {
            type: String,
            default: undefined,
            kComposite: 'scale.labels.position'
        }, 

        scaleLabelsTemplate: {
            type: [String, Function],
            default: undefined,
            kComposite: 'scale.labels.template'
        }, 

        scaleLabelsVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'scale.labels.visible'
        }, 


        scaleMajorTicksColor: {
            type: String,
            default: undefined,
            kComposite: 'scale.majorTicks.color'
        }, 

        scaleMajorTicksSize: {
            type: Number,
            default: undefined,
            kComposite: 'scale.majorTicks.size'
        }, 

        scaleMajorTicksVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'scale.majorTicks.visible'
        }, 

        scaleMajorTicksWidth: {
            type: Number,
            default: undefined,
            kComposite: 'scale.majorTicks.width'
        }, 


        scaleMajorUnit: {
            type: Number,
            default: undefined,
            kComposite: 'scale.majorUnit'
        }, 

        scaleMax: {
            type: Number,
            default: undefined,
            kComposite: 'scale.max'
        }, 

        scaleMin: {
            type: Number,
            default: undefined,
            kComposite: 'scale.min'
        }, 

        scaleMinorTicksColor: {
            type: String,
            default: undefined,
            kComposite: 'scale.minorTicks.color'
        }, 

        scaleMinorTicksSize: {
            type: Number,
            default: undefined,
            kComposite: 'scale.minorTicks.size'
        }, 

        scaleMinorTicksVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'scale.minorTicks.visible'
        }, 

        scaleMinorTicksWidth: {
            type: Number,
            default: undefined,
            kComposite: 'scale.minorTicks.width'
        }, 


        scaleMinorUnit: {
            type: Number,
            default: undefined,
            kComposite: 'scale.minorUnit'
        }, 

        scaleRangeLineCap: {
            type: String,
            default: undefined,
            kComposite: 'scale.rangeLineCap'
        }, 

        scaleRangePlaceholderColor: {
            type: String,
            default: undefined,
            kComposite: 'scale.rangePlaceholderColor'
        }, 

        scaleRangeSize: {
            type: Number,
            default: undefined,
            kComposite: 'scale.rangeSize'
        }, 

        scaleRangeDistance: {
            type: Number,
            default: undefined,
            kComposite: 'scale.rangeDistance'
        }, 

        scaleReverse: {
            type: Boolean,
            default: undefined,
            kComposite: 'scale.reverse'
        }, 

        scaleStartAngle: {
            type: Number,
            default: undefined,
            kComposite: 'scale.startAngle'
        }

    }
}


// WEBPACK FOOTER //
// ./packages/kendo-gauges-vue-wrapper/src/KendoArcGauge/Scale.js